import { registerMutation } from '@adornis/baseql/metadata/register.js';
import { getCollection } from '@adornis/baseql/server/collections.js';
import { CurrentUserInfo } from '@adornis/users/db/currentUserInfo.js';
import { Teacher } from '../teacher.js';

const VALID_KINDNESS_VALUES = ['lenient', 'balanced', 'strict'] as const;
type GradingKindness = (typeof VALID_KINDNESS_VALUES)[number];

export const setTeacherGradingKindnessMutation = registerMutation({
  operationName: 'setTeacherGradingKindnessMutation',
  type: () => Boolean,
  params: [{ name: 'gradingKindness', type: () => String }],

  resolve: (gradingKindness: string) => async () => {
    const sessionData = await CurrentUserInfo.getCurrentUserInfo()({ userID: 1 });

    if (!sessionData?.userID) {
      throw new Error('Nicht autorisiert: Kein User eingeloggt');
    }

    const resolvedKindness: GradingKindness = VALID_KINDNESS_VALUES.includes(gradingKindness as GradingKindness)
      ? (gradingKindness as GradingKindness)
      : 'balanced';

    const teacherCollection = await getCollection(Teacher);

    const result = await teacherCollection.updateOne(
      { userID: sessionData.userID },
      { $set: { gradingKindness: resolvedKindness } },
    );

    return result.matchedCount > 0;
  },
});
